import { createSlice } from '@reduxjs/toolkit';
import { AuthViewState } from 'Douleutaras/views/auth-view/types';
import { RootState } from 'Douleutaras/redux/store';

export interface AuthViewProps {
  view: AuthViewState;
  email?: string;
  fullname?: string;
  emailVerified: boolean;
  setPasswordOnly: boolean;
}

export const authViewSlice = createSlice({
  name: 'authView',
  initialState: {
    view: undefined,
    subTitle: undefined,
    emailVerified: undefined,
    setPasswordOnly: undefined
  } as AuthViewProps,
  reducers: {
    updateAuthView: (state, action) => {
      state.view = action.payload;
    },
    updateAuthViewState: (state, action) => {
      Object.keys(action.payload)
        .forEach(key => {
          state[key] = action.payload[key];
        });
    }
  }
});

export const { updateAuthView, updateAuthViewState } = authViewSlice.actions;
export const selectAuthView = (state: RootState) => state.authView;
export default authViewSlice.reducer;
